import initialState from './initialState';
import { types } from '../actions/authActions';

const {
   LOGIN_REQUEST,
   LOGIN_SUCCESS,
   LOGIN_FAIL,
   LOGOUT,
   SET_KEY
} = types;

const reducer = (state = initialState.auth, action = {}) => {
   switch (action.type) {
   case LOGIN_REQUEST:
      return Object.assign({}, state, {
         isAuthenticating: true,
         isAuthenticated: false,
         isPristine: false
      });
   case LOGIN_SUCCESS:
      return Object.assign({}, state, {
         token: action.auth.token,
         user: action.auth.user,
         isAuthenticating: false,
         isAuthenticated: true,
         roles: action.auth.roles,
         error: null,
         isPristine: false
      });
   case LOGIN_FAIL:
      return Object.assign({}, initialState.auth, {
         error: action.auth.error,
         isPristine: false
      });
   case LOGOUT:
      return Object.assign({}, initialState.auth, {
         isPristine: false
      });
   case SET_KEY:
      return Object.assign({}, state, {
         key: action.auth.key
      });
   default:
      return state;
  }
};

export default reducer;
